import * as React from "react"
  
const BackArrow = (props) => (
    <svg width={props.width} height={props.height} className={props.className} viewBox="0 0 21 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"Atoms/UI/Icons/Arrow/back"}</title>
    <g fill="none" fillRule="evenodd" stroke="#1B1B1B" strokeLinecap="round">
      <path strokeLinejoin="round" d="M9 1 1.083 9 9 17" />
      <path d="M1.083 9.002h19" />
    </g>
  </svg>
)
export default BackArrow